import { useTranslation } from "next-i18next";
import { DESKTOP_ITEM_COUNT } from "../../util/category/category-utils";
import styles from "./ResultLabel.module.scss";
function getCurrentProducts({
  totalHits,
  currentPage,
  hasProducts,
  pageSize,
}: any) {
  if (hasProducts) {
    let start = 1;
    const end = currentPage * pageSize;
    if (currentPage > 1) {
      start = (currentPage - 1) * pageSize + 1;
    }
    return `${start} - ${end > totalHits ? totalHits : end}`;
  }
  return "";
}

export default function ResultLabel(props: any) {
  const {
    totalHits, currentPage, hasProducts, pageSize = DESKTOP_ITEM_COUNT,
  } = props;
  const { t } = useTranslation("category");

  return (
    <div className={`hidden-xs ${styles.label_results}`}>

      <span className={`${styles.opacity_7} hidden-sm`}>
        {t("Showing")}
        &nbsp;
      </span>

      <span className={styles.strong}>
        {getCurrentProducts({
          totalHits,
          currentPage,
          hasProducts,
          pageSize,
        })}
      </span>
      {Boolean(hasProducts) && ` ${t("of")} `}

      <span className={styles.strong} data-testid="total-hits">{totalHits}</span>

      <span className={styles.opacity_7}>
        &nbsp;
        {t("results")}
      </span>
    </div>
  );
}
